import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSupabaseAuth } from '@/contexts/SupabaseAuthContext';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Box } from 'lucide-react';

const PackageHeader = () => {
  const navigate = useNavigate();
  const { user, logout } = useSupabaseAuth();

  const handleLogout = () => {
    logout();
    navigate('/auth');
  };

  return (
    <header className="bg-white border-b p-4">
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={() => navigate('/dashboard')}
            className="mr-2"
          >
            <ArrowLeft size={16} />
          </Button>
          <div className="flex items-center space-x-2">
            <Box className="h-5 w-5 text-primary" />
            <h1 className="text-xl font-bold hidden sm:block">Package Management</h1>
          </div>
        </div>
        
        <div className="flex items-center space-x-4">
          <span className="text-sm text-muted-foreground">
            Logged in as: {user?.user_metadata?.username || user?.email}
          </span>
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={handleLogout}
          >
            Logout
          </Button>
        </div>
      </div>
    </header>
  );
};

export default PackageHeader;
